import { useTranslation } from 'react-i18next'
import { Col, Row } from 'react-bootstrap'
import PropTypes from 'prop-types'
import FullLogo from '../../assets/logos/full-logo.png'
import theme from '../../constants/theme'
import {
  FooterContent,
  Typography,
  InfoCard,
  BannerDecorCircleLarge,
  BannerDecorCircleSmall,
  TalentPoolFormHeader,
  TalentPoolFormLogoTile,
  TalentPoolFormLogoImg,
  TalentPoolFormHeaderTitle,
  TalentPoolFormHeaderSubtitle,
} from '../styled'
import AbstractForm from '../forms/AbstractForm'
import ProgressBar from '../progress-bar/progressBar'
import LanguagesDropdown from '../languageDropdown'
import { getCompanyInitials } from '../../utilities/stringUtilities'

function TalentPoolForm({
  talentPool,
  company,
  formInputs,
  validationSchema,
  actions,
  defaultValues,
  progressRef,
  errorRef,
}) {
  const { t } = useTranslation()

  return (
    <div style={{ backgroundColor: '#F1F5FA', overflowX: 'clip' }}>
      {/* ========header */}
      <Row
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          backgroundColor: theme.white,
          padding: '0px 20px',
        }}
      >
        <Col xs="auto">
          <img height="auto" width="150px" src={FullLogo} alt="" />
        </Col>
        <Col />
        <Col xs="auto" className="mt-3">
          <LanguagesDropdown />
        </Col>
      </Row>
      <Row className="mt-4 pb-5 justify-content-center">
        <Col sm={12} md={8}>
          <InfoCard className="overflow-hidden">
            <TalentPoolFormHeader>
              <BannerDecorCircleLarge />
              <BannerDecorCircleSmall />
              <TalentPoolFormLogoTile>
                {company?.logo ? (
                  <TalentPoolFormLogoImg
                    src={company.logo}
                    alt={`${company?.companyName} logo`}
                  />
                ) : (
                  getCompanyInitials(company?.companyName)
                )}
              </TalentPoolFormLogoTile>
              <div style={{ zIndex: 1 }}>
                <TalentPoolFormHeaderTitle>
                  {t('pages.joinTalentPool')}
                </TalentPoolFormHeaderTitle>
                <TalentPoolFormHeaderSubtitle>
                  {[talentPool?.name, company?.companyName]
                    .filter(Boolean)
                    .join(' · ')}
                </TalentPoolFormHeaderSubtitle>
              </div>
            </TalentPoolFormHeader>
            <Row className="p-3 pb-0">
              <Typography size="12px" regular style={{ color: '#4B5563' }}>
                {t('pages.talentPoolDescription')}
              </Typography>
            </Row>
            <Row className="m-3">
              <AbstractForm
                inputs={formInputs}
                schema={validationSchema}
                actions={actions}
                defaultValues={defaultValues}
              >
                <ProgressBar
                  ref={{
                    progressRef,
                    errorRef,
                  }}
                />
              </AbstractForm>
            </Row>
          </InfoCard>
        </Col>
      </Row>

      <FooterContent className="d-flex py-2 border-t border-gray-200">
        {t('footer.TalentinoAI')} © {new Date().getFullYear()}{' '}
        {t('footer.allRightsReserved')}
      </FooterContent>
    </div>
  )
}

TalentPoolForm.propTypes = {
  talentPool: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  company: PropTypes.shape({
    companyName: PropTypes.string,
    logo: PropTypes.string,
  }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  formInputs: PropTypes.arrayOf(PropTypes.object).isRequired,
  validationSchema: PropTypes.shape({}).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  actions: PropTypes.arrayOf(PropTypes.object).isRequired,

  defaultValues: PropTypes.shape({}).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  progressRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  errorRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
}

export default TalentPoolForm
